module.exports = __webpack_public_path__ + "static/media/project4.844556a7.png";